export default "__VITE_ASSET__BQ1flS8$__"